// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Admin_wrapper__mFDhB","card":"Admin_card__P8QmQ","my-button":"Admin_my-button__3oSFf","successMsg":"Admin_successMsg__u3pUA","logout":"Admin_logout__3MV5Z"};